export default __webpack_public_path__ + "static/media/Fulfillment_Recibimos_compras_clientes-10.281a94b0.svg";